export default __webpack_public_path__ + "static/media/pdfWhite.cfec0d9c.svg";